<template>
  <div class="nps-core">
    <div class="list-score-rate">
      <div
        v-for="(rating, ratingKey, index) in numbersRating"
        :key="index"
        class="rating"
        :class="['rating-' + ratingKey]"
        :style="{ '--rating-color': rating.color }"
      >
        <div
          v-for="number in rating.value"
          :key="number"
          class="nps-option score-nps"
          :class="{ checked: number === activeNumber }"
          :style="{ '--rating-color': rating.color }"
          @click="handleChangeScore(number)"
        >
          <input
            :id="number"
            v-model="score"
            name="score"
            type="radio"
            :class="{ checked: number === activeNumber }"
            :value="number"
          />
          <label :for="number">{{ number }}</label>
        </div>
      </div>
    </div>
    <div class="rating-icon">
      <div class="rating-icon__weak">
        <i class="far fa-frown"></i>
      </div>
      <div class="rating-icon__good">
        <i class="far fa-smile"></i>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NpsScore',
  data() {
    return {
      numbersRating: {
        weak: {
          value: [0, 1, 2, 3, 4, 5, 6],
          color: '#ff3c44'
        },
        rather: {
          value: [7, 8],
          color: '#fdcb27'
        },
        good: {
          value: [9, 10],
          color: '#00e266'
        }
      },
      activeNumber: 8,
      score: 8
    }
  },
  methods: {
    handleChangeScore(number) {
      this.activeNumber = number
      this.score = number
      this.$emit('handleChangeScore', this.score)
    }
  }
}
</script>
